import cx from 'classnames';
import * as React from 'react';

import Text, { TextAlign } from 'components/Text';

import { TextElement } from 'components/Text';

import './OrganizationEngagementViewHeading.scss';

type Props = {
  align?: TextAlign;
  children: React.ReactNode;
  cta?: React.ReactNode;
  element?: TextElement;
  subtext?: React.ReactNode;
};

export default function OrganizationEngagementViewHeading({
  cta,
  children,
  element,
  subtext,
  ...props
}: Props) {
  return (
    <header className="OrganizationEngagementViewHeading">
      <Text
        {...props}
        element={element}
        font="serif"
        className={cx(
          'OrganizationEngagementViewHeading-title',
          element && `OrganizationEngagementViewHeading-title--${element}`
        )}>
        {children}
      </Text>
      {subtext && (
        <Text element="p" size="small" className="OrganizationEngagementViewHeading-subtext">
          {subtext}
        </Text>
      )}
      {cta && (
        <Text align="center" element="div" className="OrganizationEngagementViewHeading-cta">
          {cta}
        </Text>
      )}
    </header>
  );
}

OrganizationEngagementViewHeading.defaultProps = {
  element: 'h2',
};
